import React from 'react'
import { ContentHeader } from '../layout/Content'

function HelpHeader() {
  return ( <ContentHeader title='Help'/> );
}

export default React.memo(HelpHeader)
